export const TECHNOLOGIES_WITH_SOLUTIONS = ['force/package', 'force/bolt', 'force/flow', 'force/lightning', 'quip/package', 'b2c-commerce/package', 'salesforce-platform/api', 'b2c-commerce/api', 'marketing-cloud/api', 'tableau/accelerator', 'force/copilot'];
export const SOLUTION_IDS = ['force/Api', 'force/Package', 'quip/Api', 'quip/Package', 'marketing-cloud/Api', 'marketing-cloud/Package', 'b2c/Api', 'b2c/Package', 'tableau/Accelerator'];
export const SALESFORCE_SUPPORTED_EDITIONS = ['PE', 'EE', 'UE', 'DE', 'PP', 'ES'];
export const TECH_TYPE_ICON_MAP = {
  'b2c-commerce/api': 'b2c',
  'b2c-commerce/package': 'b2c',
  'force/bolt': 'force',
  'force/flow': 'force',
  'force/lightning': 'force',
  'force/package': 'force',
  'marketing-cloud/api': 'marketing',
  'quip/package': 'quip',
  'salesforce-platform/api': 'force',
  TrialTemplate: 'force',
  consultant: 'consultant',
  'tableau/accelerator': 'tableau',
  'force/copilot': 'astro_agent'
};
export const TECH_SOLUTION_TYPE_ICON_MAP = {
  'b2c/Api': 'b2c',
  'b2c/Package': 'b2c',
  'force/Package': 'force',
  'force/Api': 'force',
  'marketing-cloud/Api': 'marketing',
  'marketing-cloud/Package': 'marketing',
  'quip/Api': 'quip',
  'quip/Package': 'quip',
  TrialTemplate: 'force'
};
export const TECHNOLOGY_EXTENSION_MAP = {
  'force/package': 'listing/extensions/force/listings/Listing',
  'force/bolt': 'listing/extensions/force/listings/Listing',
  'force/flow': 'listing/extensions/force/listings/Listing',
  'force/lightning': 'listing/extensions/force/listings/Listing',
  'salesforce-platform/api': 'listing/extensions/force/listings/Listing',
  'quip/package': 'listing/extensions/quip/listings/Listing',
  'b2c-commerce/package': 'listing/extensions/b2c/listings/Listing',
  'b2c-commerce/api': 'listing/extensions/b2c/listings/Listing',
  'marketing-cloud/api': 'listing/extensions/marketing-cloud/listings/Listing',
  'tableau/accelerator': 'listing/extensions/tableau/listings/Listing',
  'force/copilot': 'listing/extensions/force/listings/CopilotListing',
  consultant: 'listing/extensions/consultant/listings/Listing'
};
export const TECHNOLOGY_SOLUTION_MAP = {
  'b2c-commerce/api': 'b2c/Api',
  'b2c-commerce/package': 'b2c/Package',
  'force/bolt': 'force/Package',
  'force/flow': 'force/Package',
  'force/lightning': 'force/Package',
  'force/package': 'force/Package',
  'marketing-cloud/api': 'marketing-cloud/Api',
  'quip/package': 'quip/Package',
  'salesforce-platform/api': 'force/Api',
  'tableau/accelerator': 'tableau/Accelerator',
  'force/copilot': 'force/Package'
};
export const TECHNOLOGY_SOLUTION_EXTENSION_MAP = {
  'force/package': 'listing/extensions/force/listings/Listing/extensions/PackageListing',
  'force/bolt': 'listing/extensions/force/listings/Listing/extensions/PackageListing',
  'force/flow': 'listing/extensions/force/listings/Listing/extensions/PackageListing',
  'force/lightning': 'listing/extensions/force/listings/Listing/extensions/PackageListing',
  'salesforce-platform/api': 'listing/extensions/force/listings/Listing/extensions/APIListing',
  'quip/package': 'listing/extensions/quip/listings/Listing/extensions/PackageListing',
  'b2c-commerce/package': 'listing/extensions/b2c/listings/Listing/extensions/PackageListing',
  'b2c-commerce/api': 'listing/extensions/b2c/listings/Listing/extensions/APIListing',
  'marketing-cloud/api': 'listing/extensions/marketing-cloud/listings/Listing/extensions/APIListing',
  'tableau/accelerator': 'listing/extensions/tableau/listings/Listing/extensions/AcceleratorListing',
  'force/copilot': 'listing/extensions/force/listings/Listing/extensions/CopilotListing'
};
export const TECHNOLOGY_TEST_DRIVE_MAP = {
  'force/copilot': 'listing/extensions/force/listings/Listing/extensions/PackageListing/TestDrive',
  'force/package': 'listing/extensions/force/listings/Listing/extensions/PackageListing/TestDrive',
  'force/bolt': 'listing/extensions/force/listings/Listing/extensions/PackageListing/TestDrive',
  'force/flow': 'listing/extensions/force/listings/Listing/extensions/PackageListing/TestDrive',
  'force/lightning': 'listing/extensions/force/listings/Listing/extensions/PackageListing/TestDrive',
  'salesforce-platform/api': 'listing/extensions/force/listings/Listing/extensions/APIListing/TestDrive',
  'quip/package': 'listing/extensions/quip/listings/Listing/extensions/PackageListing/TestDrive',
  'marketing-cloud/api': 'listing/extensions/marketing-cloud/listings/Listing/extensions/APIListing/TestDrive'
};
export const NON_FORCE_PACKAGE_SOLUTION_TYPES = ['b2c-commerce/api', 'marketing-cloud/api', 'salesforce-platform/api', 'b2c-commerce/package', 'tableau/accelerator'];
export const SOLUTION_TYPES_SR_REQUIRED = ['marketing-cloud/api', 'salesforce-platform/api'];
export function isHeadlessIntegrationForB2C(solutionType) {
  switch (solutionType) {
    case 'b2c/Api':
      return true;
    default:
      return false;
  }
}
export function isLinkType(solutionType) {
  switch (solutionType) {
    case 'b2c/Api':
    case 'b2c/Package':
      return true;
    default:
      return false;
  }
}
export function isConsultantType(technology) {
  return technology === 'consultant';
}
export function isCopilotType(technology) {
  return technology === 'force/copilot';
}
export function isForcePackageType(technology) {
  return technology === 'force/package';
}
export function isTableauType(technology) {
  return technology === 'tableau/accelerator';
}
export function isApiSolutionType(solutionType) {
  switch (solutionType) {
    case 'b2c/Api':
    case 'force/Api':
    case 'quip/Api':
    case 'marketing-cloud/Api':
      return true;
    default:
      return false;
  }
}
export function isNonForcePackageSolutionType(solutionType) {
  switch (solutionType) {
    case 'b2c/Package':
    case 'quip/Package':
    case 'tableau/Accelerator':
      return true;
    default:
      return false;
  }
}
export function isTableauSolutionType(solutionType) {
  switch (solutionType) {
    case 'tableau/Accelerator':
      return true;
    default:
      return false;
  }
}

// From:
// A) Salesforce Email Address Validation RFCs compliance: https://help.salesforce.com/s/articleView?id=000384328&type=1
// B) Salesforce Marketing Cloud Engagement API/SDKs: https://developer.salesforce.com/docs/marketing/marketing-cloud/guide/using_regular_expressions_to_validate_email_addresses.html
export function validateEmail(email) {
  return typeof email === 'string' && email.length <= 80 && /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:[a-zA-Z0-9!#$%&'*+./=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9]*[a-zA-Z0-9])?$/.test(email);
}

//Validates 15 or 18 characters long OrgId
export function validateOrgId(orgid) {
  return /^(00D[a-zA-Z0-9]{12}|00D[a-zA-Z0-9]{15})$/.test(orgid);
}

//Validates 15 or 18 characters long CampaignId
export function validateCampaignId(campaignId) {
  return /^(701[a-zA-Z0-9]{12}|701[a-zA-Z0-9]{15})$/.test(campaignId);
}
export function validateUrl(url) {
  try {
    // eslint-disable-next-line no-new
    const givenURL = new URL(url);
    return givenURL.protocol === 'http:' || givenURL.protocol === 'https:';
  } catch {
    /* noop */
  }
  return false;
}
export function selectEnum(schema) {
  var _schema$items;
  if (schema && 'additionalItems' in schema) {
    var _schema$additionalIte;
    return (_schema$additionalIte = schema.additionalItems) === null || _schema$additionalIte === void 0 ? void 0 : _schema$additionalIte.enum;
  }
  //Added this condition as a workaround for the issue we are facing while creating the schema.registry.ts on OAF side.
  //Right now when maxItems property is aded in the .json definition, unnecessary items are added to the array in schema.registry file.
  //E.g:
  // productsSupported: {
  //     type: 'array',
  //     items: [
  //         {
  //             type: 'string',
  //             enum: [
  //                 'Experience Cloud',
  //                 'Marketing Cloud',
  //                 'Pardot',
  //                 'Financial Services Cloud',
  //                 'Health Cloud',
  //                 'Government Cloud',
  //             ],
  //         },
  //         {
  //             type: 'string',
  //             enum: [
  //                 'Experience Cloud',
  //                 'Marketing Cloud',
  //                 'Pardot',
  //                 'Financial Services Cloud',
  //                 'Health Cloud',
  //                 'Government Cloud',
  //             ],
  //         },
  //         {
  //             type: 'string',
  //             enum: [
  //                 'Experience Cloud',
  //                 'Marketing Cloud',
  //                 'Pardot',
  //                 'Financial Services Cloud',
  //                 'Health Cloud',
  //                 'Government Cloud',
  //             ],
  //         },
  //     ],
  //     default: [],
  //     uniqueItems: true,
  //     minItems: 0,
  //     maxItems: 3,
  //     description:
  //         '(New field) This is supplimentary information that may add more context to the relevant input.',
  //     sensitivityLevel: 'public',
  // },
  if (Array.isArray(schema === null || schema === void 0 ? void 0 : schema.items)) {
    var _schema$items$;
    return schema === null || schema === void 0 ? void 0 : (_schema$items$ = schema.items[0]) === null || _schema$items$ === void 0 ? void 0 : _schema$items$.enum;
  }
  return schema === null || schema === void 0 ? void 0 : (_schema$items = schema.items) === null || _schema$items === void 0 ? void 0 : _schema$items.enum;
}
export function getPlugin(state, pluginType) {
  var _state$plugins, _state$plugins$find;
  return (_state$plugins = state.plugins) === null || _state$plugins === void 0 ? void 0 : (_state$plugins$find = _state$plugins.find(test => test.pluginType === pluginType)) === null || _state$plugins$find === void 0 ? void 0 : _state$plugins$find.data;
}